<template>
    <v-app>
        <v-main class="main">
            <transition name="fade" class="fill-height">
                <router-view></router-view>
            </transition>
        </v-main>

        <!-- snackbar -->
        <v-snackbar
            :timeout="snackbarDuration"
            :color="snackbarColor"
            top
            v-model="showSnackbar">
            {{ snackbarMessage }}
        </v-snackbar>

        <div class="alert" :class="showAlert ? 'active' : ''" v-show="showAlert">
            <v-layout class="alert-body" fill-height align-center justify-center>
                <div class="message" v-html="alertMessage"></div>
            </v-layout>
            <div class="btn-confirm" v-if="alertButtons">
                <img v-for="(button, index) in alertButtons" :src="button.image" @click="v => {button.cb(); $playAudio(1) }"
                     v-if="button.image"
                />
                <v-btn v-for="(button, index) in alertButtons" :key="index" @click="v => {button.cb(); $playAudio(1)}"
                       v-if="button.text" color="primary" class="ml-2"
                >{{button.text}}</v-btn>
            </div>
            <div class="btn-confirm" v-else>
                <v-btn>확인</v-btn>
            </div>
        </div>

        <!-- dialog confirm -->
        <v-dialog v-show="showDialog" v-model="showDialog" :persistent="dialogType=='confirm'" absolute max-width="450px">
            <v-card>
                <v-card-title>
                    <div class="headline"><v-icon v-if="dialogIcon">{{dialogIcon}}</v-icon> {{ dialogTitle }}</div>
                </v-card-title>
                <v-card-text v-html="dialogMessage"></v-card-text>
                <v-card-actions v-if="dialogType=='confirm' || dialogType=='alert'">
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click.native="dialogCancel" v-show="dialogType=='confirm'">Cancel</v-btn>
                    <v-btn color="primary" text @click.native="dialogOk" class="btn-alert-ok">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-app>
</template>

<script>

    import io from 'socket.io-client';

    export default {
        name: 'App',

        components: {
        },

        data() {
            return {
                transitionName: '',
            }
        },
        computed: {
            socketServerHost() {
                // console.log(process.env.VUE_)
                return process.env.NODE_ENV === 'production' ? '//wss.onlyonelife.co.kr' : '//192.168.1.12:8765'
            },
            showSnackbar: {
                get() {
                    return this.$store.getters.showSnackbar;
                },
                set(val) {
                    if(!val) this.$store.commit('hideSnackbar');
                }
            },
            snackbarMessage() {
                return this.$store.getters.snackbarMessage;
            },
            snackbarColor() {
                return this.$store.getters.snackbarColor;
            },
            snackbarDuration() {
                return this.$store.getters.snackbarDuration;
            },


            // dialog
            showDialog: {
                get() {
                    return this.$store.getters.showDialog;
                },
                set(val) {
                    if(!val) this.$store.commit('hideDialog');
                }
            },
            dialogType() {
                return this.$store.getters.dialogType
            },
            dialogTitle() {
                return this.$store.getters.dialogTitle
            },
            dialogMessage() {
                return this.$store.getters.dialogMessage ? this.$store.getters.dialogMessage.replace(/\n/g, '<br />') : ''
            },
            dialogIcon() {
                return this.$store.getters.dialogIcon
            },

            showAlert() {
                return this.$store.getters.showAlert
            },
            alertMessage() {
                return (this.$store.getters.alertMessage || '').replace(/\n/g, '<br />')
                    .replace(/\[([^\]]+)\]/g, '<span class="highlight">$1</span>')
                    .replace(/\{([^\}|\|w|\|h]+)(\|w([0-9.]+))?(\|h([0-9.]+))?\}/g, '<span><img src="$1" style="width:$3px;height:$5px;vertical-align:middle;" /></span>')
            },

            alertButtons() {
                return this.$store.getters.alertButtons
            },

            appBarShow() {
                return this.$store.getters.appBarShow
            },

            appBarTitle() {
                return this.$store.getters.appBarTitle
            },

            userData() {
                return this.$userData
            },
        },

        watch: {
            showDialog(val) {
                if (val) {
                    setTimeout(_ => {
                        $('.btn-alert-ok').focus()
                    })
                }
            },

            '$route.path'(val) {
                const id = this.$cookie.get('id')

                if (val !== '/login') {
                    if (!this.socket) {

                        this.socket = io(this.socketServerHost, {
                            transports: ['websocket'],
                            secure: true,
                        })
                        this.setSocketListener()
                    }

                    if (val !== '/sheet' && id) {
                        if (this.$cookie.get(`in_sheet${id}`)) {
                            this.$router.replace('/sheet')
                        }
                    }

                    if (id) {
                        this.axios.get('/api/templates').then(response => {
                            this.setTemplates(response.data.result)
                        })
                    }

                }

                if (id) {
                    const params = {
                        path: val
                    }
                    this.axios.post('/api/progress', params)
                }
            }
        },

        beforeMount() {
            const self = this

            this.$loadAudio()

            this.axios.interceptors.request.use(function (config) {
                const token = self.$cookie.get('token')
                if (token) {
                    config.headers.token = token
                }
                return config;
            }, function (error) {
                // Do something with request error
                console.log('axios.request.error', error)
                return Promise.reject(error);
            });

            // Add a response interceptor
            this.axios.interceptors.response.use(function (response) {
                if (response.data.code === '9901' || response.data.code === '9999') {
                    // 	self.$store.commit('showSnackbar',{
                    // 		message: response.data.message,
                    // 		color: 'error',
                    // 		duration: 3000
                    // 	});
                    self.$router.push('/').catch(()=>{})
                }
                return response;
            }, function (error) {
                if (!error.response || error.code === 'ECONNABORTED') {
                    // timeout of 0ms exceeded
                } else {
                    self.$store.commit('showSnackbar', {
                        message: error,
                        color: 'error',
                        duration: 3000
                    });
                }
                return Promise.reject(error);
            });

        },


        mounted() {

            const id = this.$cookie.get('id')
            if (this.$route.path !== '/login' && this.$route.path !== '/sheet' && id) {
                if (this.$cookie.get(`in_sheet${id}`)) {
                    this.$router.replace('/sheet')
                }
            }

            if (this.$route.path !== '/login') {

                this.axios.get('/api/templates').then(response => {
                    this.setTemplates(response.data.result)
                })
            }

            if (this.$route.path !== '/login' && !this.$cookie.get('token')) {
                this.$router.replace('/login')
                return
            }

            if (this.$route.path !== '/login') {
                this.socket = io(this.socketServerHost, {
                    transports: ['websocket'],
                    secure: true,
                })
                this.setSocketListener()
            }

            this.axios.get('/api/ages').then(response => {
                this.$set(this.$gameData, 'ages', response.data.result)
            })

            this.axios.get('/api/questions').then(response => {
                this.$set(this.$gameData, 'questions', response.data.result)
            })

            $('.email').focus()

            $(document.body).on('click', this.initAudio)

            this.$eventBus.$on('SET_ROUND', round => {
                // console.log('set round')
                this.socket.emit('setRound', round)
            })

            this.$eventBus.$on('SOCKET_CLOSE', _ => {
                this.socket.disconnect()
                this.socket = null

            })

            if (id) {
                const params = {
                    path: this.$route.path
                }
                this.axios.post('/api/progress', params)
            }

        },
        methods: {

            setSocketListener() {
                let self = this
                this.socket.on('connect', data => {
                    console.log('connected')

                    console.log('id', this.$cookie.get('id'))
                    const trainee = {
                        id: this.$cookie.get('id'),
                        training_id: this.$cookie.get('training_id'),
                        name: this.$cookie.get('name'),
                    }

                    this.socket.emit('setTrainee', trainee)
                })
                this.socket.on('disconnect', _ => {
                    console.log('disconnected')
                })

                this.socket.on('returnToGame', _ => {
                    const id = this.$cookie.get('id')
                    this.$cookie.delete(`in_sheet${id}`)
                    this.$router.push('/game')
                })

                this.socket.on('moveToSheet', _ => {
                    const id = this.$cookie.get('id')
                    this.$cookie.set(`in_sheet${id}`, true)
                    this.$router.push('/sheet')
                })

            },

            initAudio() {
                this.$eventBus.$emit('INIT_AUDIO')

                $(document.body).off('click', this.initAudio)
            },

            setTemplates(data) {
                const imageTemplate = data.imageTemplate
                const surveyTemplate = data.surveyTemplate

                const images = {}
                imageTemplate.images.forEach(image => {
                    let age, gender
                    switch (image.type) {
                        case 'logo':
                            images.logo = {
                                url: image.url
                            }
                            break;
                        case 'tutorial':
                            if (!images.tutorial) {
                                images.tutorial = []
                            }
                            images.tutorial.push({
                                no: image.no,
                                url: image.url
                            })
                            break;
                        case 'titleleaf':
                            if (!images.titleleaf) {
                                images.titleleaf = {}
                            }

                            age = image.no.replace(/[^0-9]+/, '')
                            gender = image.no.replace(/[0-9]+/, '') || 'a'
                            if (!images.titleleaf[age]) {
                                images.titleleaf[age] = {}
                            }
                            if (!images.titleleaf[age][gender]) {
                                images.titleleaf[age][gender] = {}
                            }
                            images.titleleaf[age][gender] = {
                                no: image.no,
                                url: image.url
                            }
                            break;
                        case 'background':
                            if (!images.background) {
                                images.background = {}
                            }

                            age = image.no
                            if (!images.background[age]) {
                                images.background[age] = {}
                            }
                            images.background[age] = {
                                no: image.no,
                                url: image.url,
                                width: image.width
                            }
                            break;
                    }
                })
                this.$set(this.$gameData, 'images', images)

                const surveys = {}
                surveyTemplate.surveys.forEach(survey => {
                    surveys[survey.question_id] = survey
                })

                this.$set(this.$gameData, 'surveys', surveys)

            },



            dialogOk() {
                this.$playAudio(1)
                this.$store.commit('dialogOk');
            },
            dialogCancel() {
                this.$playAudio(1)
                this.$store.commit('dialogCancel');
            },

            alertOk() {
                this.$store.commit('alertOk')
            },

        }

    };
</script>

<style lang="scss" scoped>
    main {
        background-color: #000000;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
    .alert {
        position: fixed;
        top: 0; bottom: 0;
        left: 0; right: 0;
        z-index: 1000;

        background: #191818;
        padding: 3%;
        opacity: 0;
        transition: all 0.3s ease-in;

        &.active {
            opacity: 1;
            animation: fadeIn 0.2s;
        }


        .alert-body {
            border: 5px solid #ffffff;
            border-radius: 5px;
            background-color: #787067;

            .message {
                font-size: 20px;
                font-weight: 400;
                line-height: 1.75;
                text-align: center;
                color: #ffffff;
                padding-bottom: 7%;

                .highlight {
                    color: #febd36;
                }
            }
        }

        .btn-confirm {
            position: fixed;
            bottom: 14%;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            img {

                &+img {
                    margin-left: 5%;
                }
            }
        }
    }
</style>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition-property: opacity;
        transition-duration: .25s;
    }
    .fade-enter-active {
        transition-delay:
            .25s;
    }
    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

    .alert-body .highlight {
        color: #febd36;
    }

    .preloader { width: 0; height: 0; overflow: hidden; position: fixed; left: 0; visibility: hidden}

</style>

